import React from "react";
import FormSelect from "../FormSelect";
import { useFetchReportFeedbackAspectsQuery } from "../../../services/clientreports";

const ReportFeedbackAspectsSelect = ({ options, ...rest }) => {
    const { data, error, isError, isLoading, isFetching } = useFetchReportFeedbackAspectsQuery({ fetchType: 'List' });
    const { results } = data || { results: [] }

    const dataOptions = React.useMemo(() => {
            if (!results) {
                return [];
            }
    
            return results.map((el) => {
                return {
                    label: el.description,
                    value: el.id
                };
            })
        }, [ results ]);

    return <FormSelect
        options={dataOptions}
        isLoadingOptions={isLoading || isFetching}
        {...rest}
    />
};

export default ReportFeedbackAspectsSelect;